"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterScanSeaAndAirNorwayAS = void 0;
exports.InterScanSeaAndAirNorwayAS = {
    id: 'interScanSeaAndAirNorwayAS',
    companyName: 'Inter-Scan Sea & Air Norway AS',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'interScanSeaAndAirNorwayAS',
    },
    isInternal: false,
    isActive: true,
    countries: ['NO'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW50ZXJTY2FuU2VhQW5kQWlyTm9yd2F5QVMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvYWdlbnRzL2RhdGEvSW50ZXJTY2FuU2VhQW5kQWlyTm9yd2F5QVMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSwwQkFBMEIsR0FBVTtJQUM3QyxFQUFFLEVBQUUsNEJBQTRCO0lBQ2hDLFdBQVcsRUFBRSxnQ0FBZ0M7SUFDN0MsY0FBYyxFQUFFLENBQUMsS0FBSyxFQUFFLEtBQUssQ0FBQztJQUM5QixXQUFXLEVBQUU7UUFDVCxXQUFXLEVBQUUsSUFBSTtRQUNqQixLQUFLLEVBQUUsNEJBQTRCO0tBQ3RDO0lBQ0QsVUFBVSxFQUFFLEtBQUs7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxTQUFTLEVBQUUsQ0FBQyxJQUFJLENBQUM7Q0FDcEIsQ0FBQSJ9